import { Grid, Switch } from '@mui/material';
import { HSpacer, RoutalDialog, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { Subscription } from '../../../../../domain/backoffice/subscription/Subscription';
import { useUpdateSubscriptionWhatsApp } from '../../../../../hooks/backoffice/subscriptions/useUpdateSubscriptionWhatsApp';
import Button from '../../../../../react-components/Button';
import InputText from '../../../../../react-components/InputText';
import Text from '../../../../../react-components/Text';

type BackofficeClientsOrganizationsManageWhatsAppDialogProps = {
  openDialog: boolean;
  organizationId: string;
  subscription: Subscription;
  onClose: (hasBeenUpdated: boolean) => void;
};

export const BackofficeClientsOrganizationsManageWhatsAppDialog = ({
  openDialog,
  organizationId,
  subscription,
  onClose,
}: BackofficeClientsOrganizationsManageWhatsAppDialogProps) => {
  const { run: manageSubscriptionWhatsApp, isLoading, success } = useUpdateSubscriptionWhatsApp();
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [increasedCredit, setIncreasedCredit] = useState<number>(0);
  const [from, setFrom] = useState<string | undefined>(undefined);
  const [subaccountId, setSubaccountId] = useState<string | undefined>(undefined);

  useEffect(() => {
    setIsEnabled(subscription.whatsapp.enabled);
  }, [subscription]);

  useEffect(() => {
    if (success) {
      onClose(true);
    }
  }, [onClose, success]);

  if (!openDialog) return null;

  const isSaveButtonDisabled = () => {
    return (
      isLoading ||
      (isEnabled === subscription.whatsapp.enabled &&
        increasedCredit === 0 &&
        from === undefined &&
        subaccountId === undefined)
    );
  };

  console.log(subscription.whatsapp);

  return (
    <RoutalDialog
      open={openDialog}
      onCloseDialog={() => onClose(false)}
      dialogProps={{
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      }}
      titleContent={<Text variant="h6" intlId="administration.users.manage_whatsapp.title" />}
      titleRightContent={
        <Text
          variant="label"
          intlId="administration.users.manage_whatsapp.remaining"
          intlValues={{ number: subscription.whatsapp.credit ?? 0 }}
        />
      }
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button intlId="cancel" variant="flat" onClick={() => onClose(false)} />
          <HSpacer small />
          <Button
            intlId="send"
            disabled={isSaveButtonDisabled()}
            onClick={async () => {
              manageSubscriptionWhatsApp({
                organizationId,
                enabled: isEnabled,
                from: from ? from : undefined,
                subaccountId: subaccountId ? subaccountId : undefined,
                increasedCredit: increasedCredit !== 0 ? increasedCredit : undefined,
              });
            }}
          />
        </Grid>
      }
    >
      <Grid container direction="row" alignItems="center" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Text intlId="administration.users.manage_whatsapp.enable" />
        </Grid>
        <Grid item>
          <Switch
            checked={isEnabled}
            value={isEnabled}
            onChange={(event: any) => {
              const { checked } = event.target;
              setIsEnabled(checked);
            }}
            color="primary"
          />
        </Grid>
      </Grid>

      <VSpacer medium />

      <InputText
        type="number"
        label={<Text variant="label" intlId="administration.users.manage_whatsapp.increase_whatsapp" />}
        placeholderIntlId="administration.users.manage_whatsapp.increase_whatsapp_ph"
        fieldValue={increasedCredit}
        onChange={setIncreasedCredit}
      />

      <VSpacer large />

      <InputText
        label={<Text variant="label" intlId="administration.users.manage_whatsapp.from" />}
        placeholderIntlId="administration.users.manage_whatsapp.from_ph"
        fieldValue={from}
        onChange={(newFrom) => (newFrom ? setFrom(newFrom) : setFrom(undefined))}
      />

      <VSpacer large />

      <InputText
        label={<Text variant="label" intlId="administration.users.manage_whatsapp.subaccount_id" />}
        placeholderIntlId="administration.users.manage_whatsapp.subaccount_id_ph"
        fieldValue={subaccountId}
        onChange={(newId) => (newId ? setSubaccountId(newId) : setSubaccountId(undefined))}
      />
    </RoutalDialog>
  );
};
